export default __webpack_public_path__ + "static/media/028-pet-food.074daaac.svg";